import { queryOptions } from '@tanstack/react-query';
import { getUpcomingHomeMatches } from './prismic';
import { getGames, getGame, getPlayers, getSettings } from './queries';
import type { Game, Player, PrismicMatch, Settings } from './types';

export const gamesQueryOptions = () =>
  queryOptions({ queryKey: ['games'], queryFn: getGames });

export const gameQueryOptions = (id: string) =>
  queryOptions<Game>({ queryKey: ['games', id], queryFn: () => getGame(id) });

export const playersQueryOptions = () =>
  queryOptions<Player[]>({ queryKey: ['players'], queryFn: getPlayers });

export const settingsQueryOptions = () =>
  queryOptions<Settings>({ queryKey: ['settings'], queryFn: getSettings });

export const prismicMatchesQueryOptions = () =>
  queryOptions<PrismicMatch[]>({
    queryKey: ['prismic-matches'],
    queryFn: getUpcomingHomeMatches,
    staleTime: 1000 * 60 * 5,
  });
